const ADMIN_EMAIL_FALLBACKS = ['contato@aerodestinytravel.com'];

interface AdminIdentity {
  email?: string | null;
}

export function getAeroAdminEmails(configuredEmails = ''): string[] {
  const configured = configuredEmails
    .split(',')
    .map((email) => email.trim().toLowerCase())
    .filter(Boolean);

  return Array.from(new Set([...configured, ...ADMIN_EMAIL_FALLBACKS]));
}

export function isAeroAdminCandidate(user: AdminIdentity | null | undefined, configuredEmails = ''): boolean {
  const email = user?.email?.trim().toLowerCase() ?? '';
  return Boolean(email && getAeroAdminEmails(configuredEmails).includes(email));
}

export function canManageAeroAdminAccess(email: string | null | undefined, configuredEmails = ''): boolean {
  return isAeroAdminCandidate({ email }, configuredEmails);
}

export function resolveAuthenticatedEntryPath(
  user: AdminIdentity | null | undefined,
  requestedPath: string,
  configuredEmails = '',
): string {
  if (!isAeroAdminCandidate(user, configuredEmails)) return requestedPath;

  const pathname = requestedPath.split(/[?#]/, 1)[0];
  if (pathname === '/app/dashboard' || pathname === '/app/new-trip') {
    return '/app/travel-desk';
  }

  return requestedPath;
}

export function getAuthenticatedHomePath(user: AdminIdentity | null | undefined, configuredEmails = ''): string {
  return isAeroAdminCandidate(user, configuredEmails) ? '/app/travel-desk' : '/app/dashboard';
}
